import { gql, useMutation } from '@apollo/client';

import type {
  SendPhoneVerificationCodeMutation,
  SendPhoneVerificationCodeMutationVariables,
} from './__generated__/useSendPhoneVerificationCode.gql';

const SEND_PHONE_VERIFICATION_CODE = gql`
  mutation SendPhoneVerificationCode {
    sendPhoneVerificationCode {
      retryAfter
    }
  }
`;

export const useSendPhoneVerificationCode = () => {
  return useMutation<SendPhoneVerificationCodeMutation, SendPhoneVerificationCodeMutationVariables>(
    SEND_PHONE_VERIFICATION_CODE
  );
};
